import { Injector, Provider } from "@angular/core";
import { TranslateLoader } from "@ngx-translate/core";
import { CustomTranslateHttpLoader } from "../common/custom-translate-http-loader";

export const TranslateLoaderProvider: Provider = {
  provide: TranslateLoader,
  useFactory: (injector: Injector) => new CustomTranslateHttpLoader(injector),
  deps: [Injector]
};